/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ firstName: NonNullable<unknown>, lastName: NonNullable<unknown> }} Welcome_User_MessageInputs */

const en_welcome_user_message = /** @type {(inputs: Welcome_User_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome ${i?.firstName} ${i?.lastName}!`)
};

const de_welcome_user_message = /** @type {(inputs: Welcome_User_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willkommen ${i?.firstName} ${i?.lastName}!`)
};

/**
* | output |
* | --- |
* | "Welcome {firstName} {lastName}!" |
*
* @param {Welcome_User_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const welcome_user_message = /** @type {((inputs: Welcome_User_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_User_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_welcome_user_message(inputs)
	return en_welcome_user_message(inputs)
});